exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-radio-box h3[data-v-7a6b083a] {\n  color: rgba(0,0,0,0.6);\n  font-weight: normal;\n  font-size: 12px;\n  margin-bottom: -10px;\n}\n.app-radio-box h3 span[data-v-7a6b083a] {\n  color: #ff5252;\n  margin-left: 3px;\n}\n", ""]);

// exports
